import { useBaseCurrencyContext } from '~contexts/BaseСurrencyContext'

export const useBaseCurrency = () => {
    const { baseCurrency } = useBaseCurrencyContext()

    const displayedBaseCurrency = baseCurrency.code
    const calculatedBaseCurrency = baseCurrency.codeForRateCalculations || displayedBaseCurrency

    return {
        calculatedBaseCurrency,
        displayedBaseCurrency,
    }
}
